export const GET_TAG_INFORMATION = 'GET_TAG_INFORMATION' // 申请的标签信息（初始化坑位信息
export const UPDATE_APPLICATION_PLATFORM_LIST = 'UPDATE_APPLICATION_PLATFORM_LIST' // 勾选平台更新
export const UPDATE_IMGAE_LIST = 'UPDATE_IMGAE_LIST' // 上传成功的坑位列表
export const UPDATE_BELT_IMGAE_LIST = 'UPDATE_BELT_IMGAE_LIST' // 上传成功的腰带类型列表
export const CHANGE_TAB = 'CHANGE_TAB' // 切换标签页的 tab栏
